<template>
    <client-page>
        <sub-visual-full bg="/images/sub/visual/sv2-1.jpg">
            <h2 class="font-weight-thin" data-aos="fade-down" data-aos-duration="1200">영업 실적은 물론,</h2>
            <div data-aos="fade-right" data-aos-duration="1400">
                <h2 class="font-weight-bold ani--fill">브랜드의 가치까지 전달합니다.</h2>
            </div>
        </sub-visual-full>

        <section class="page-section--fixed page-section--fixed1" v-scroll="onScrollFixedA">
            <div class="fixed-contents">
                <div class="fixed-bg"></div>
                <v-container>
                    <section class="section">
                        <div class="tit-wrap color-white">
                            <h3 class="tit">서비스 소개</h3>
                        </div>

                        <div class="business-intro" v-scroll="onScrollFixedD">
                            <v-divider style="border-color: rgba(255, 255, 255, 0.3)" class="border-2 mb-18 mb-lg-36"></v-divider>

                            <v-row class="ma-lg-0 text-center business-intro-items">
                                <v-col cols="12" sm="4" class="pa-lg-0 mb-n8 business-intro-item">
                                    <p class="page-text--sm color-point line-height-1 mb-4 mb-lg-10">
                                        Subscription
                                    </p>
                                    <h5 class="tit-txt font-weight-bold color-white">
                                        서비스 홍보 및 구독자 확보
                                    </h5>
                                </v-col>
                                <v-col cols="12" sm="4" class="pa-lg-0 mb-n8 business-intro-item">
                                    <p class="page-text--sm color-point line-height-1 mb-4 mb-lg-10">
                                        Commercial
                                    </p>
                                    <h5 class="tit-txt font-weight-bold color-white">
                                        국내외 제품 세일즈 및 홍보
                                    </h5>
                                </v-col>
                                <v-col cols="12" sm="4" class="pa-lg-0 business-intro-item">
                                    <p class="page-text--sm color-point line-height-1 mb-4 mb-lg-10">
                                        Fundraising
                                    </p>
                                    <h5 class="tit-txt font-weight-bold color-white">
                                        NGO 단체 후원자 유치
                                    </h5>
                                </v-col>
                            </v-row>
                        </div>
                    </section>
                    <section class="section pt-0">
                        <div class="mb-50">
                            <v-row>
                                <v-col cols="12" md="6" data-aos="fade-right">
                                    <img src="/images/sub/business/introduction/s1-img1.jpg" alt="" class="d-block w-100">
                                </v-col>
                                <v-col cols="12" md="6" data-aos="fade-left" data-aos-delay="300">
                                    <div class="mt-md-180 mt-lg-250 pl-md-20 pl-xl-66">
                                        <h4 class="bar-text bar-text--lg color-white mb-6 mb-lg-12">
                                            서비스 홍보 및 구독자확보
                                        </h4>
                                        <p class="tit-txt color-grey-d">
                                            다양한 국가에서 25년간 축적한 경험과 노하우를 바탕으로
                                            자체 세일즈 팀이 없거나, 보다 나은 영업 실적을 원하는
                                            고객사의 제품 세일즈, 서비스 홍보, 구독자 확보를 전문적으로
                                            대행합니다.
                                        </p>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <div class="mb-50 mb-lg-100">
                            <v-row class="flex-column-reverse flex-md-row">
                                <v-col cols="12" md="6" data-aos="fade-right">
                                    <div class="pr-md-20 pr-xl-66">
                                        <h4 class="bar-text bar-text--lg color-white mb-6 mb-lg-12">
                                            국내외 제품 세일즈 및 홍보
                                        </h4>
                                        <p class="tit-txt color-grey-d">
                                            세일즈웍스의 세일즈 & 구독 대행 서비스는 영업 전문가인
                                            브랜드 홍보대사의 대면 영업을 통해 잠재고객 한 명 한 명에게
                                            맞춤형 홍보가 가능합니다. 구독자 확보에 최적화된
                                            세일즈웍스만의 독자적인 서비스는 구독경제 시대에 더욱
                                            주목 받고 있습니다.
                                        </p>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6" data-aos="fade-left" data-aos-delay="300">
                                    <img src="/images/sub/business/introduction/s1-img2.jpg" alt="" class="d-block w-100 mt-md-50 mt-lg-100">
                                </v-col>
                            </v-row>
                        </div>
                        <div>
                            <v-row>
                                <v-col cols="12" md="6" data-aos="fade-right">
                                    <img src="/images/sub/business/introduction/s1-img3.jpg" alt="" class="d-block w-100">
                                </v-col>
                                <v-col cols="12" md="6" data-aos="fade-left" data-aos-delay="300">
                                    <div class="mt-md-180 mt-lg-250 pl-md-20 pl-xl-66">
                                        <h4 class="bar-text bar-text--lg color-white mb-6 mb-lg-12">
                                            NGO 단체 후원자 유치
                                        </h4>
                                        <p class="tit-txt color-grey-d">
                                            NGO 단체에 특화된 서비스를 위한 펀드레이징 전문 브랜드,
                                            서포트웍스는 전문 펀드레이저와 함께 NGO의 가치와 의미를
                                            전달하고 후원자를 유치합니다.
                                        </p>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </section>
                </v-container>
            </div>
        </section>

        <section class="section business-banner text-center color-white w-100 font-size-32 font-size-md-46 font-size-lg-60 line-height-13" style="background-color: #000;" v-scroll="onScrollFixedC">
            <v-container>
                <h3 class="font-weight-thin fade-down">공감을 이끌어내는 가장 좋은 방법,</h3>
                <div class="fade-right">
                    <h3 class="ani--fill--scr color-white">Face to Face</h3>
                </div>
            </v-container>
        </section>

        <section class="page-section--fixed page-section--fixed2" v-scroll="onScrollFixedB">
            <div class="fixed-contents">
                <div class="fixed-bg"></div>
                <section class="section">
                    <v-container>
                        <div class="tit-wrap color-white">
                            <h3 class="tit">Face to Face만이 줄 수 있는 가치</h3>
                        </div>
                        <div class="mb-50">
                            <v-row>
                                <v-col cols="12" md="6" data-aos="fade-right">
                                    <img src="/images/sub/business/introduction/s2-img1.jpg" alt="" class="d-block w-100">
                                </v-col>
                                <v-col cols="12" md="6" data-aos="fade-left" data-aos-delay="300">
                                    <div class="mt-md-180 mt-lg-250 pl-md-20 pl-xl-66">
                                        <h4 class="bar-text bar-text--lg color-white mb-6 mb-lg-12">
                                            미디어로 전하기 어려운 가치 전달
                                        </h4>
                                        <p class="tit-txt color-grey-d">
                                            넘쳐나는 디지털 정보 속에 소비자들은 믿을 수 있는
                                            정보, 사람의 온기가 느껴지는 경험을 필요로 합니다.
                                            세일즈웍스는 의뢰받은 상품 또는 서비스에 대한 깊은
                                            이해를 바탕으로 고객과 직접 대화하며 소통하는 대면
                                            캠페인을 기획하고 진행합니다. 
                                        </p>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <div class="mb-50 mb-lg-100">
                            <v-row class="flex-column-reverse flex-md-row">
                                <v-col cols="12" md="6" data-aos="fade-right">
                                    <div class="pr-md-20 pr-xl-66">
                                        <h4 class="bar-text bar-text--lg color-white mb-6 mb-lg-12">
                                            1:1 맞춤형 서비스 설계
                                        </h4>
                                        <p class="tit-txt color-grey-d">
                                            브랜드 홍보대사는 담당하는 제품 및 서비스의 전문가가
                                            될 때까지 체계적인 교육을 받고 홍보를 통해 긍정적인
                                            브랜드 이미지를 전달합니다. 대화를 통해 호감을
                                            형성하고 고객 한 명 한 명에게 신뢰도 높은 정보를
                                            제공하기 때문에 판매 성과 및 서비스 구독 전환율이
                                            높습니다. 
                                        </p>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6" data-aos="fade-left" data-aos-delay="300">
                                    <img src="/images/sub/business/introduction/s2-img2.jpg" alt="" class="d-block w-100 mt-md-50 mt-lg-100">
                                </v-col>
                            </v-row>
                        </div>
                        <div>
                            <v-row>
                                <v-col cols="12" md="6" data-aos="fade-right">
                                    <img src="/images/sub/business/introduction/s2-img3.jpg" alt="" class="d-block w-100">
                                </v-col>
                                <v-col cols="12" md="6" data-aos="fade-left" data-aos-delay="300">
                                    <div class="mt-md-180 mt-lg-250 pl-md-20 pl-xl-66">
                                        <h4 class="bar-text bar-text--lg color-white mb-6 mb-lg-12">
                                            고객의 직접적인 피드백 수집
                                        </h4>
                                        <p class="tit-txt color-grey-d">
                                            서포트웍스의 펀드레이저는 전문 펀드레이저 양성 과정,
                                            온라인 프로그램, NGO 단체의 교육 등을 거쳐 확고한
                                            윤리관과 책임감으로 NGO의 가치를 전달합니다.
                                        </p>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>
                </section>
            </div>
        </section>

        <section class="section color-white" style="background-image: url(/images/sub/business/introduction/s3-bg.jpg); background-position: center bottom; background-size: 100% auto; background-color: #000;">
            <v-container>
                <div class="tit-wrap">
                    <h3 class="tit">산업분야</h3>
                </div>
            </v-container>
            <div class="business-slide">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="business-slide__inner">
                                <v-row>
                                    <v-col cols="2">
                                        <img src="/images/sub/business/introduction/s3-img1.jpg" alt="" class="d-block w-100 mb-12 mb-lg-36">
                                        <h5 class="tit-txt line-height-1 font-weight-bold mb-6 mb-lg-14">
                                            IT
                                        </h5>
                                        <p class="page-text--sm color-grey-d">
                                            플랫폼 비즈니스
                                        </p>
                                    </v-col>
                                    <v-col cols="2">
                                        <img src="/images/sub/business/introduction/s3-img2.jpg" alt="" class="d-block w-100 mb-12 mb-lg-36">
                                        <h5 class="tit-txt line-height-1 font-weight-bold mb-6 mb-lg-14">
                                            금융
                                        </h5>
                                        <p class="page-text--sm color-grey-d">
                                            카드, 보험, 금융상품
                                        </p>
                                    </v-col>
                                    <v-col cols="2">
                                        <img src="/images/sub/business/introduction/s3-img3.jpg" alt="" class="d-block w-100 mb-12 mb-lg-36">
                                        <h5 class="tit-txt line-height-1 font-weight-bold mb-6 mb-lg-14">
                                            서비스
                                        </h5>
                                        <p class="page-text--sm color-grey-d">
                                            교육, 통신, 미디어
                                        </p>
                                    </v-col>
                                    <v-col cols="2">
                                        <img src="/images/sub/business/introduction/s3-img4.jpg" alt="" class="d-block w-100 mb-12 mb-lg-36">
                                        <h5 class="tit-txt line-height-1 font-weight-bold mb-6 mb-lg-14">
                                            펀드레이징
                                        </h5>
                                        <p class="page-text--sm color-grey-d">
                                            NGO, NPO, 자선단체
                                        </p>
                                    </v-col>
                                    <v-col cols="2">
                                        <img src="/images/sub/business/introduction/s3-img5.jpg" alt="" class="d-block w-100 mb-12 mb-lg-36">
                                        <h5 class="tit-txt line-height-1 font-weight-bold mb-6 mb-lg-14">
                                            소비재
                                        </h5>
                                        <p class="page-text--sm color-grey-d">
                                            화장품, 생활용품, 차량용품
                                        </p>
                                    </v-col>
                                    <v-col cols="2">
                                        <img src="/images/sub/business/introduction/s3-img6.jpg" alt="" class="d-block w-100 mb-12 mb-lg-36">
                                        <h5 class="tit-txt line-height-1 font-weight-bold mb-6 mb-lg-14">
                                            에너지
                                        </h5>
                                        <p class="page-text--sm color-grey-d">
                                            지속가능 에너지 솔루션
                                        </p>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </client-page>
</template>

<script>
import Swiper from "swiper/bundle";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisualFull from "@/components/client/sub/sub-visual-full.vue";
export default {
    components: {
        ClientPage,
        SubVisualFull,
    },
    mounted() {
        this.init();
    }, 
    methods: {
        onScrollFixedA: function(){
            var scrollTop = window.scrollY || document.documentElement.scrollTop;
            var pageSectionFixed = document.querySelector('.page-section--fixed1');
            var fixedContentsLeft = document.querySelector('.page-section--fixed1 .fixed-bg');
            if(pageSectionFixed !== null){
                var pageSectionFixedTop = pageSectionFixed.offsetTop;
                var pageSectionFixedHeight = pageSectionFixed.clientHeight;
                var fixedContentsLeftHeight = fixedContentsLeft.clientHeight;
                var pageSectionFixedBottom = pageSectionFixedTop + pageSectionFixedHeight - fixedContentsLeftHeight;
                var fixedContentsLeftTranslate = pageSectionFixedHeight - fixedContentsLeftHeight;
                if(scrollTop > pageSectionFixedTop){
                    pageSectionFixed.classList.add('active');
                }else {
                    pageSectionFixed.classList.remove('active');
                }
                if(scrollTop > pageSectionFixedBottom){
                    pageSectionFixed.classList.add('bottom');
                    fixedContentsLeft.style.transform = 'translate(0px,' + fixedContentsLeftTranslate + 'px)';
                }else{
                    pageSectionFixed.classList.remove('bottom');
                    fixedContentsLeft.style = '';
                }
            }
        },
        onScrollFixedB: function(){
            var scrollTop = window.scrollY || document.documentElement.scrollTop;
            var pageSectionFixed = document.querySelector('.page-section--fixed2');
            var fixedContentsLeft = document.querySelector('.page-section--fixed2 .fixed-bg');
            if(pageSectionFixed !== null){
                var pageSectionFixedTop = pageSectionFixed.offsetTop;
                var pageSectionFixedHeight = pageSectionFixed.clientHeight;
                var fixedContentsLeftHeight = fixedContentsLeft.clientHeight;
                var pageSectionFixedBottom = pageSectionFixedTop + pageSectionFixedHeight - fixedContentsLeftHeight;
                var fixedContentsLeftTranslate = pageSectionFixedHeight - fixedContentsLeftHeight;
                if(scrollTop > pageSectionFixedTop){
                    pageSectionFixed.classList.add('active');
                }else {
                    pageSectionFixed.classList.remove('active');
                }
                if(scrollTop > pageSectionFixedBottom){
                    pageSectionFixed.classList.add('bottom');
                    fixedContentsLeft.style.transform = 'translate(0px,' + fixedContentsLeftTranslate + 'px)';
                }else{
                    pageSectionFixed.classList.remove('bottom');
                    fixedContentsLeft.style = '';
                }
            }
        },
        onScrollFixedC: function(){
            var scrollTop = window.scrollY || document.documentElement.scrollTop;
            var banner = document.querySelector('.business-banner');
            if(banner !== null){
                var pageSectionFixedTop = banner.offsetTop - 500;
                if(scrollTop > pageSectionFixedTop){
                    banner.classList.add('active');
                }
            }
        },
        onScrollFixedD: function(){
            var scrollTop = window.scrollY || document.documentElement.scrollTop;
            var banner = document.querySelector('.business-intro');
            if(banner !== null){
                var pageSectionFixedTop = banner.offsetTop + 300;
                if(scrollTop > pageSectionFixedTop){
                    banner.classList.add('active');
                }
            }
        },
        async init() {
            this.$nextTick(() => {

                this.Business = new Swiper ('.business-slide .swiper-container', {
                    centeredSlides: true,
                    spaceBetween: 12,
                    loop: true,
                    autoplay: {
                        delay: 1,
                        disableOnInteraction: false,
                    },
                    speed: 15000,
                    breakpoints: {
                        1024: {
                            freeMode: true,
                            spaceBetween: 36,
                            speed: 20000,
                        },
                    },
                });

            });
        },
    }
};
</script>

<style scoped>
.fixed-bg{
    position:absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    opacity: 0;
    transition: 1s opacity ease-out;
}

.page-section--fixed{
    background-color: #000;
}

.page-section--fixed1 .fixed-bg{
    background-image: url(/images/sub/business/introduction/s1-bg.jpg);
}

.page-section--fixed2 .fixed-bg{
    background-image: url(/images/sub/business/introduction/s2-bg.jpg);
}

.page-section--fixed.active .fixed-bg{
    position: fixed;
    opacity: 1;
}

.page-section--fixed.bottom .fixed-bg{
    position: absolute !important;
    bottom: 0;
    opacity: 0;
}

.fixed-contents{
    position: relative;
}

.business-intro .v-divider{
    transition: 1.5s ease-out;
    transform: scaleX(0);
    transform-origin: left center;
}

.business-intro.active .v-divider{
    transform: scaleX(1);
}

.business-intro-item{
    opacity: 0;
    transition: 2s;
}

.business-intro.active .business-intro-item{
    opacity: 1;
}

.business-intro-items .business-intro-item:nth-child(1){
    transition-delay: 1s;
}
.business-intro-items .business-intro-item:nth-child(2){
    transition-delay: 1.1s;
}
.business-intro-items .business-intro-item:nth-child(3){
    transition-delay: 1.2s;
}

.business-slide{
    min-width: 1260px;
    width: 1260px;
}

.business-slide .swiper-container{
    overflow: visible;
}
.business-slide .swiper-wrapper {
    transition-timing-function: linear;
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .business-slide{
        min-width: 1828px;
        width: 1828px;
    }
}
@media (min-width:1200px){
}

</style>